module.exports = __webpack_public_path__ + "media/images/vector-35@2x-b2e8ce2b20d846d3be8d7440ac5dd7b2.png";